import React from "react";
import { Link } from "react-router-dom";
import "./report.scss";
import { useSelector } from "react-redux";
export default function Report() {
  const { profile } = useSelector((state) => state.profile);
  return (
    <div style={{ padding: "10px 30px" }}>
      <div class="card-content mt-4">
        <div class="container-fluid">
          <div class="row mb-3">
            {profile?.Permissions?.find((x) => x?.Action === "Report.Sale.Read")
              ?.Permit && (
              <div class="col-12 col-sm-12 col-md-6 col-lg-3 mt-3">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">รายงานการจำหน่าย</h4>
                  </div>
                  <ul class="list-group list-group-flush">
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Sale.Read.40401"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-dialy-sale">
                          รายงานการจำหน่ายเมล็ดพันธุ์ (ประจำวัน) (กมข-40401)
                        </Link>
                      </li>
                    )}
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Sale.Read.40402"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-sale-agent">
                          รายงานการจำหน่ายเมล็ดพันธุ์ผ่านตัวแทนจำหน่ายฯ
                          (กมข-40402)
                        </Link>
                      </li>
                    )}
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Sale.Read.20405"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-sale">
                          รายงานผลการจำหน่ายเมล็ดพันธุ์พืชผ่านช่องทางต่างๆ
                          ประจำไตรมาส (กมข-20405)
                        </Link>
                      </li>
                    )}
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Sale.Read.40403"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-sale-location">
                          รายงานการจำหน่ายเมล็ดพันธุ์ข้าวในพื้นที่ต่างๆ
                          (กมข-40403)
                        </Link>
                      </li>
                    )}
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Sale.Read.40404"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-income">
                          รายงานรายรับจากการจำหน่ายเมล็ดพันธุ์ (กมข-40404)
                        </Link>
                      </li>
                    )}
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Sale.Read.40406"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-customer">
                          ทะเบียนผู้ซื้อเมล็ดพันธุ์ (กมข-40406)
                        </Link>
                      </li>
                    )}
                    {/* {profile?.Permissions?.find((x) => x?.Action === 'Report.Sale.Read.40407')?.Permit &&
                    <li class="list-group-item">
                      <Link to='/report/report-agent'>ทะเบียนรายชื่อตัวแทนจำหน่ายเมล็ดพันธุ์พืช (กมข-40407)</Link>
                    </li>} */}
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Sale.Read.40408"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-sale-promotion">
                          รายงานการจำหน่ายเมล็ดพันธุ์ลดราคาเฉพาะกิจ (กมข-40408)
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            )}

            {profile?.Permissions?.find(
              (x) => x?.Action === "Report.Stock.Read"
            )?.Permit && (
              <div class="col-12 col-sm-12 col-md-6 col-lg-3  mt-3">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">รายงานคลังเมล็ดพันธุ์</h4>
                  </div>
                  <ul class="list-group list-group-flush">
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Stock.Read.20404"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-stock">
                          {" "}
                          รายงานสถานการณ์การตลาดและคลังเมล็ดพันธุ์ (กมข-20404)
                        </Link>
                      </li>
                    )}
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Stock.Read.40405"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-transfer">
                          รายงานการโอนเมล็ดพันธุ์ (กมข-40405)
                        </Link>
                      </li>
                    )}
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Stock.Read.20406"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-receive">
                          {" "}
                          รายงานการรับเมล็ดพันธุ์ (กมข-20406)
                        </Link>
                      </li>
                    )}
                    <li class="list-group-item">
                      <Link to="/report/report-raw">
                        รายงานการรับ-จ่ายเมล็ดพันธุ์ดิบ (กมข-20407)
                      </Link>
                    </li>
                    <li class="list-group-item">
                      <Link to="/report/report-discard">
                        รายงานรับ-จ่ายเมล็ดพันธุ์คัดออกใช้ประโยชน์ได้
                        (กมข-20408)
                      </Link>
                    </li>
                    <li class="list-group-item">
                      <Link to="/report/report-rice-seed-reserve">
                        รายงานสำรองเมล็ดพันธุ์ข้าว
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            )}

            <div class="col-12 col-sm-12 col-md-6 col-lg-3">
              <div class="row">
                {profile?.Permissions?.find(
                  (x) => x?.Action === "Report.Plan.Read"
                )?.Permit && (
                  <div class="col-12  mt-3">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title">
                          รายงานแผนผลิตเมล็ดพันธุ์และจำหน่าย
                        </h4>
                      </div>
                      <ul class="list-group list-group-flush">
                        {profile?.Permissions?.find(
                          (x) => x?.Action === "Report.Plan.Read.20401"
                        )?.Permit && (
                          <li class="list-group-item">
                            <Link to="/report/report-plan-production">
                              รายงานศักยภาพและแผนผลิตเมล็ดพันธุ์ข้าวประจำปี
                              (กมข-20401)
                            </Link>
                          </li>
                        )}
                        {/* {profile?.Permissions?.find((x) => x?.Action === 'Report.Plan.Read.30401')?.Permit &&
                        <li class="list-group-item">
                          <Link to='/report/report-plan-review'>รายงานศักยภาพและแผนผลิตเมล็ดพันธุ์ข้าวประจำปี (ทบทวน) (กมข-30401)</Link>
                        </li>
                      } */}
                        {profile?.Permissions?.find(
                          (x) => x?.Action === "Report.Plan.Read.20402"
                        )?.Permit && (
                          <li class="list-group-item">
                            <Link to="/report/report-plan-sale">
                              แผนการจำหน่ายเมล็ดพันธุ์ข้าว (กมข-20402)
                            </Link>
                          </li>
                        )}
                        {profile?.Permissions?.find(
                          (x) => x?.Action === "Report.Plan.Read.20403"
                        )?.Permit && (
                          <li class="list-group-item">
                            <Link to="/report/report-plan-distribution">
                              แผนส่งเสริมการกระจายเมล็ดพันธุ์ข้าว (กมข-20403)
                            </Link>
                          </li>
                        )}
                        {/* {profile?.Permissions?.find((x) => x?.Action === 'Report.Plan.Read.30403')?.Permit &&
                    <li class="list-group-item">
                      <Link to='/report/report-inspection'>ใบตรวจการปฏิบัติงาน (กมข-30403)</Link>
                    </li>
                  } */}
                      </ul>
                    </div>
                  </div>
                )}
                {profile?.Permissions?.find(
                  (x) => x?.Action === "Report.Delivery.Read"
                )?.Permit && (
                  <div class="col-12  mt-3">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title">รายงานการขนส่ง</h4>
                      </div>
                      <ul class="list-group list-group-flush">
                        {profile?.Permissions?.find(
                          (x) => x?.Action === "Report.Delivery.Read.30402"
                        )?.Permit && (
                          <li class="list-group-item">
                            <Link to="/report/report-delviery-cost">
                              รายงานการจ้างขนส่งเมล็ดพันธุ์ (กมข-30402)
                            </Link>
                          </li>
                        )}
                        {profile?.Permissions?.find(
                          (x) => x?.Action === "Report.Delivery.Read.30402_1"
                        )?.Permit && (
                          <li class="list-group-item">
                            <Link to="/report/report-fuel-cost">
                              รายงานค่าน้ำมันเชื้อเพลิงในการขนส่งเมล็ดพันธุ์
                              (กมข-30402(1))
                            </Link>
                          </li>
                        )}
                        {profile?.Permissions?.find(
                          (x) => x?.Action === "Report.Delivery.Read.30404"
                        )?.Permit && (
                          <li class="list-group-item">
                            <Link to="/report/report-delviery-ten">
                              รายงานสรุปผลการจัดส่งเมล็ดพันธุ์ (กมข-30404)
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {profile?.Permissions?.find(
              (x) => x?.Action === "Report.Stock.Read"
            )?.Permit && (
              <div class="col-12 col-sm-12 col-md-6 col-lg-3  mt-3">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">รายงานอื่นๆ</h4>
                  </div>
                  <ul class="list-group list-group-flush">
                    {/* {profile?.Permissions?.find((x) => x?.Action === 'Report.Stock.Read.20404')?.Permit && */}
                    {/* <li class="list-group-item">
                    <Link to='/report/report-raw'>รายงานการรับ-จ่ายเมล็ดพันธุ์ดิบ</Link>
                  </li> */}
                    {/* } */}
                    {/* {profile?.Permissions?.find((x) => x?.Action === 'Report.Stock.Read.40405')?.Permit && */}
                    <li class="list-group-item">
                      <Link to="/report/report-receipt">
                        รายงานใบเสร็จรับเงิน
                      </Link>
                    </li>
                    {/* } */}
                    {/* {profile?.Permissions?.find((x) => x?.Action === 'Report.Stock.Read.20406')?.Permit && */}
                    <li class="list-group-item">
                      <Link to="/report/report-cost">
                        รายงานต้นทุนการผลิต (กมข-20410)
                      </Link>
                    </li>
                    {/* } */}
                    {/* {profile?.Permissions?.find((x) => x?.Action === 'Report.Stock.Read.20406')?.Permit && */}
                    <li class="list-group-item">
                      <Link to="/report/report-seed-produce-cost-by-item">
                        รายงานต้นทุนการผลิตรายพันธุ์ (กมข-20411)
                      </Link>
                    </li>
                    {/* } */}
                    {/* {profile?.Permissions?.find((x) => x?.Action === 'Report.Stock.Read.20406')?.Permit && */}
                    {/* <li class="list-group-item">
                    <Link to='/report/report-discard'>รายงานรับ-จ่ายเมล็ดพันธุ์คัดออกใช้ประโยชน์ได้</Link>
                  </li> */}
                    {/* } */}
                    {/* {profile?.Permissions?.find((x) => x?.Action === 'Report.Stock.Read.20406')?.Permit && */}
                    <li class="list-group-item">
                      <Link to="/report/report-balane-materials">
                        รายงานวัสดุการผลิตคงคลัง (กมข-20409)
                      </Link>
                    </li>
                    {/* } */}
                    <li class="list-group-item">
                      <Link to="/report/report-material-production">
                        รายงานวัสดุการผลิต
                      </Link>
                    </li>
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Plan.Read.30403"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-inspection">
                          ใบตรวจการปฏิบัติงาน (กมข-30403)
                        </Link>
                      </li>
                    )}
                    {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Sale.Read.40407"
                    )?.Permit && (
                      <li class="list-group-item">
                        <Link to="/report/report-agent">
                          ทะเบียนรายชื่อตัวแทนจำหน่ายฯ (กมข-40407)
                        </Link>
                      </li>
                    )}
                    {/* {profile?.Permissions?.find(
                      (x) => x?.Action === "Report.Sale.Read.40407"
                    )?.Permit && ( */}
                      <li class="list-group-item">
                        <Link to="/report/lot-movement-report">
                          ข้อมูลเมล็ดพันธุ์ข้าวตามเลขที่ล็อต
                        </Link>
                      </li>
                      <li class="list-group-item">
                        <Link to="/report/day-in-stock-report">
                          รายงานจำนวนวันเก็บรักษาเมล็ดพันธุ์เหลือคงคลัง
                        </Link>
                      </li>
                    {/* )} */}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
